import { Route, Routes, createRouterPanel } from 'weblite-router'
import { RoomList } from '$scenes/room-list'
import { Room } from '$scenes/room'
import { Home } from '$scenes/home'
import { Profile } from '$scenes/profile'
import { RoomProfile } from '$scenes/room-profile'
import { Mavakeb } from '$scenes/mavakeb'
import { Rahkar } from '$scenes/rahkar'
import { Jaryan } from '$scenes/jaryan'
import { Kooleh } from '$scenes/kooleh'
import { Wapp } from '$scenes/wapp'
import { WappOverlay } from '$scenes/wapp-overlay'
import { ModalViewerOverlay } from '$scenes/modal-viewer-overlay'
import { ChatListSearch } from '$comp/_app/components/leftPanel/components/chat-list-search/chat-list-search'
import { Call } from '$scenes/call'
import { PvCallManager } from '$scenes/pv-call-manager'
import { Vitrine } from '$scenes/vitrine'
import { Story } from '$scenes/story'
import { SjfSignup } from '$scenes/sjf-signup'
import { CourseVitrine } from '$scenes/course-vitrine'

export const RoomListPanel = createRouterPanel(
  'roomList',
  <Routes>
    <Route name="roomList" routeTransitions={{ name: 'zoomFade' }}>
      <Route name="roomList" element={<RoomList />} />
      <Route name="search" element={<ChatListSearch />} />
    </Route>
  </Routes>,
  { location: 'roomList/roomList' },
)

export const ProfilePanel = createRouterPanel('profile', <Profile />)

export const RoomProfilePanel = createRouterPanel(
  'roomProfile',
  <RoomProfile />,
)

export const MavakebPanel = createRouterPanel(
  'mavakeb',
  <Routes>
    <Route name="mavakeb" element={<Mavakeb />} />
  </Routes>,
)

export const RahkarPanel = createRouterPanel(
  'rahkar',
  <Routes>
    <Route name="rahkar" element={<Rahkar />} />
  </Routes>,
)

export const JaryanPanel = createRouterPanel(
  'jaryan',
  <Routes>
    <Route name="jaryan" element={<Jaryan />} />
  </Routes>,
)

export const KoolehPanel = createRouterPanel(
  'kooleh',
  <Routes>
    <Route name="kooleh" element={<Kooleh />} />
  </Routes>,
)

export const HomePanel = createRouterPanel(
  'home',
  <Routes>
    <Route name="home" element={<Home />} />
  </Routes>,
  { location: 'home', state: { tab: 'roomList' } },
)

export const RoomPanel = createRouterPanel('room', <Room />, {
  location: 'startPage',
})

export const WappPanel = createRouterPanel(
  'wapp',
  <Routes>
    <Route name="wapp" element={<Wapp />} />
  </Routes>,
)

export const VitrinePanel = createRouterPanel(
  'vitrine',
  <Routes>
    <Route name="vitrine" element={<Vitrine />} />
  </Routes>,
  { location: 'vitrine' },
)
export const CourseVitrinePanel = createRouterPanel(
  'courseVitrine',
  <Routes>
    <Route name="courseVitrine" element={<CourseVitrine />} />
  </Routes>,
  { location: 'courseVitrine' },
)

export const CallPanel = createRouterPanel(
  'call',
  <Routes>
    <Route name="call" element={<Call />} />
  </Routes>,
  { location: 'call' },
)

export const SJFSignupPanel = createRouterPanel(
  'sjfSignup',
  <Routes>
    <Route name="profileCompletion" element={<SjfSignup />} />
  </Routes>,
  { location: 'profileCompletion' },
)

export const PvCallManagerPanel = createRouterPanel(
  'pvCallManager',
  <Routes>
    <Route name="pvCallManager" element={<PvCallManager />} />
  </Routes>,
  { location: 'pvCallManager' },
)

export const StoryPanel = createRouterPanel(
  'story',
  <Routes>
    <Route name="story" element={<Story />} />
  </Routes>,
  { location: 'story' },
)

export const OverlayWappPanel = createRouterPanel(
  'overlayWapp',
  <Routes>
    <Route name="wapp" element={<WappOverlay />} />
  </Routes>,
)

export const ModalsPanel = createRouterPanel(
  'modals',
  <Routes>
    <Route name="modal" element={<ModalViewerOverlay />} />
  </Routes>,
)
